import { useUserData } from '@conteg/auth';
import { usePolicyEvaluate } from 'components/policy-loader/policy-loader';
import { CUSTOM_AUTH_TOKEN } from 'config';

/**
 * The franchise view is for the provider (OXLS) only. There is no dedicated
 * OPA action for it yet, so it reuses `createCompany` on `organization` —
 * the provider-only action held by GlobalAdmin and CompanyManager, i.e.
 * exactly the people who onboard franchisees. Must be used inside
 * PolicyLoader (any protected route).
 */
export const useCanViewFranchises = () => {
  const userData = useUserData(CUSTOM_AUTH_TOKEN);
  const passesPolicy = usePolicyEvaluate('createCompany', 'organization');

  return !!userData?.isProvider && !!passesPolicy;
};
